<template>
  <el-card style="width: 32%;">
    <div ref="statistics" style="height: 350px;" v-show="statisticsData && statisticsData.length"></div>
    <el-empty description="暂无数据" v-show="!statisticsData || !statisticsData.length"></el-empty>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    statisticsData: Object
  },
  data() {
    return {
      myCharts: null
    }
  },
  mounted() {
    let el = this.$refs.statistics;
    el.style.width = el.parentNode.clientWidth - 40 + 'px';
  },
  watch: {
    statisticsData: {
      handler(val) {
        this.setChart();
      },
      deep: true
    }
  },
  methods: {
    setChart() {
      if (!this.myCharts) {
        this.myCharts = this.$echarts.init(this.$refs.statistics);
      }
      let statisticsData = this.statisticsData;
      if (!statisticsData || !statisticsData.length) {
        return;
      }

      let axisData = [];
      let seriesData = [];
      for (let index in statisticsData) {
        let range = statisticsData[index];
        axisData.push(range.name);
        seriesData.push(range.avgSalary)
      }

      this.myCharts.setOption({
        title: {
          text: '年龄平均月薪分布',
          left: 'center'
        },
        tooltip: {},
        grid: {
          left: '3%',
          right: '1%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: axisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      })
    }
  }
})
</script>
